"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@/components/ui";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
interface AiScribeConsentDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  patientName: string;
  onAgreed: () => void;
  onDeclined: () => void;
  isDeclining?: boolean;
}
export default function AiScribeConsentDialog(t0) {
  const $ = _c(19);
  const {
    open,
    onOpenChange,
    patientName,
    onAgreed,
    onDeclined,
    isDeclining
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DialogTitle>Did the patient agree to AI scribe?</DialogTitle>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = patientName || "the patient";
  let t3;
  if ($[1] !== t2) {
    t3 = <DialogHeader>{t1}<DialogDescription><span>Confirm that <span>{t2}</span> agreed to have this visit recorded and transcribed by AI scribe. Their answer is saved to their record.</span></DialogDescription></DialogHeader>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isDeclining || $[4] !== onDeclined) {
    t4 = <Button variant="primary" onClick={onDeclined} isLoading={isDeclining} loadingText="Saving...">Patient declined</Button>;
    $[3] = isDeclining;
    $[4] = onDeclined;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isDeclining || $[7] !== onAgreed) {
    t5 = <Button variant="secondary" onClick={onAgreed} disabled={isDeclining}>Patient agreed, start recording</Button>;
    $[6] = isDeclining;
    $[7] = onAgreed;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <DialogFooter className="sm:justify-between">{t4}{t5}</DialogFooter>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <DialogContent className="max-w-md">{t3}{t6}</DialogContent>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onOpenChange || $[16] !== open || $[17] !== t7) {
    t8 = <Dialog open={open} onOpenChange={onOpenChange}>{t7}</Dialog>;
    $[15] = onOpenChange;
    $[16] = open;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}